import { ref, type Ref } from 'vue';
import type { SearchCriteria } from '@/entities/searchCriteria';
import { generateSearchId, getSearchSessionKey } from '../lib/searchSession';

export interface SearchSession {
  searchId: Ref<string>;
  startSearchSession: (criteria: SearchCriteria) => void;
}

export function useSearchSession(restoredSearchId = ''): SearchSession {
  const searchId = ref<string>(restoredSearchId || generateSearchId());
  let lastSearchKey = '';

  const startSearchSession = (criteria: SearchCriteria): void => {
    const searchKey = getSearchSessionKey(criteria);

    if (lastSearchKey && searchKey !== lastSearchKey) searchId.value = generateSearchId();

    lastSearchKey = searchKey;
  };

  return { searchId, startSearchSession };
}
